import { getConsoleWorkspaceLanding } from '@client/components/_core/navigation/left-nav/workspace-navigation';
import type { FileRouteTypes } from '@client/routeTree.gen';
import type { Role } from '@shared/constants';
import { isFleetPortalOnlyUser } from '@shared/permissions/roles';

/**
 * Redirect users who cannot render Home to a workspace landing their roles can access: a
 * user whose only console role is attestations to that section, a Fleet-portal-only user to
 * the portal. Null means Home is the right landing, or there is no better one.
 */
export function getHomeRoleRedirectTarget(userRoles: Role[]): FileRouteTypes['to'] | null {
    const consoleLanding = getConsoleWorkspaceLanding(userRoles);
    if (consoleLanding !== '/console/$orgId') {
        return consoleLanding;
    }

    return isFleetPortalOnlyUser(userRoles) ? '/console/$orgId/fleet-portal' : null;
}
